module.exports = __webpack_public_path__ + "static/media/D98981A1-EE76-40F1-9D76-A5E3F94795EE.ce10ab0d.jpeg";